const routes_workers = [
    {
        path: '/inicio',
        component: resolve => require(['../../containers/DefaultContainer.vue'], resolve),
        children: [
            {
                path: '/trabajadores/trabajadores',
                component: resolve => require(['../../views/workers/workers/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Trabajadores',
                    permiso: ['modulo-trabajadores'],
                    breadcrumb: '/trabajadores/workers'
                }
            },
            {
                path: '/trabajadores/trabajadores/form/:company_id/:id?',
                component: resolve => require(['../../views/workers/workers/form.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Informacion general',
                    permiso: ['modulo-trabajadores'],
                    breadcrumb: '/trabajadores/trabajadores/general-information'
                }
            }
        ]
    }
];

export default routes_workers;
